<template>
  <div class="run-pipe">
    <div><b>Arkadium.com clear cache pipeline:</b></div>
    <div
      v-if="$checkRoles(['Administrator']) && $isSpecialUser()"
      class="run-pipe__btn"
      @click="runPipeline">
      <span v-if="this.pipelineStatus !== 'InProgress'">Run pipeline</span>
    </div>
    <div
      v-if="$checkRoles(['Administrator']) && $isSpecialUser()"
      class="run-pipe__btn"
      @click="getArkcomPupelineStatus(1)">
      <span>Get status</span>
    </div>
    <div v-if="this.pipelineStatus" style="min-width: 230px; min-height: 20px"><b>Status:</b> {{this.pipelineStatus}} <div v-if="this.pipelineStatus === 'InProgress'">- please wait.</div></div>
  </div>
</template>

<script>
import config from '../../config';
import {ClearCacheService} from '../../services/ClearCacheService';

export default {
    name: 'RunPipelineBtn',
    components: {},
    props: [],
    data() {
        return {
            pipelineStatus: ''
        };
    },
    methods: {
        getArkcomPupelineStatus: async function(skipTimer = 0) {
            this.$http.get(`${config.apiUrl}/runpipeline/arkcom-get-build-status`).then(
                (response) => {
                    this.pipelineStatus = response.body;
                    if (this.pipelineStatus === 'InProgress' && skipTimer !== 1) {
                        setTimeout(this.getArkcomPupelineStatus, 3000);
                    }

                    this.$swal.fire({
                        position: 'center',
                        showConfirmButton: true,
                        timer: 7000,
                        icon: 'success',
                        title: `Pipeline status: ` + this.pipelineStatus,
                        text: ''
                    });
                },
                (error) => {
                    console.log(error);
                    this.pipelineStatus = 'Error';
                }
            );
        },
        runPipeline: async function() {
            await ClearCacheService.clearCache('', ['shared-content-arkcom-game-arts'], 'Tag', 'Delete');
            await ClearCacheService.clearByArkFiles();

            this.$http.get(`${config.apiUrl}/runpipeline/arkcom-restart-pods`).then(
                (response) => {
                    this.pipelineStatus = response.body;
                    if (this.pipelineStatus === 'InProgress') {
                      this.$swal.fire({
                        position: 'center',
                        showConfirmButton: true,
                        timer: 7000,
                        icon: 'success',
                        title: `Pipeline status: ` + this.pipelineStatus + ', please wait! ',
                        text: ''
                      });
                    }
                },
                (error) => {
                    console.log(error);
                    this.pipelineStatus = 'Error';
                }
            );
        }
    }
};
</script>
<style scoped src="./RunPipeline.scss" lang="scss">
</style>
